module.exports = __webpack_public_path__ + "275ac60d7b5dbceb9d71a098fa8f2685.png";